import { BASE_API_URL } from '../consts/base-url';
import customFetch from './fetch';
import { getTaskById } from './get-task-by-id';

/**
 * Refresh the signed url for a task
 * @param taskId - The id of the task
 * @returns The signed url
 */
export const refreshSignedUrl = async (taskId: number) => {
  try {
    const task = await getTaskById(taskId);

    // Get the gcs url from the task
    let gcsUrl = '';
    switch (task.input.labellingType) {
      case 'IMAGE':
        {
          gcsUrl = task.input.imageUrl;
          break;
        }
      case 'VIDEO':
        {
          gcsUrl = task.input.videoUrl;
          break;
        }
      case 'PDF':
        {
          gcsUrl = task.input.pdfUrl;
          break;
        }
      default:
        gcsUrl = '';
    }
    if (!!gcsUrl) {
      // Refresh the signed url
      const signedUrlResponse = await customFetch(`${BASE_API_URL}/reference`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: gcsUrl
        })
      });
      if (!signedUrlResponse.ok) {
        throw new Error('Failed to refresh signed url');
      }
      const {
        signedUrl
      } = (await signedUrlResponse.json() as {
        signedUrl: string;
      });

      // Return the signed url
      return signedUrl;
    } else {
      throw new Error('No gcs url found for the task');
    }
  } catch (error) {
    console.error('Error refreshing signed url:', error);
    throw error;
  }
};